"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelemetryContextProvider = exports.useTelemetry = exports.STORAGE_KEYS = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _jsSha = require("js-sha256");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var _actions = require("../actions");

var _constants = require("../constants");

var _utils = require("../utils");

var _useImpactRadius2 = _interopRequireDefault(require("./useImpactRadius"));

var _useStoredUtmParams = _interopRequireDefault(require("./useStoredUtmParams"));

var _window;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TelemetryContext = /*#__PURE__*/(0, _react.createContext)();
var STORAGE_KEYS = {
  uuid: 'telemetry_uuid',
  trackerUuid: 'telemetry_trackerUuid',
  epoch: 'telemetry_epoch',
  appEvents: 'telemetry_appEvents',
  userEvents: 'telemetry_userEvents',
  webEvents: 'telemetry_webEvents'
};
exports.STORAGE_KEYS = STORAGE_KEYS;
var APP_EVENT_KEYS = {
  APP: 'appEvents',
  USER: 'userEvents',
  WEB: 'webEvents'
};

var getSessionKey = function getSessionKey() {
  try {
    var _window$sessionStorag, _window$sessionStorag2, _window$localStorage;

    var key = {
      uuid: (_window$sessionStorag = window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem(STORAGE_KEYS.uuid),
      epoch: (_window$sessionStorag2 = window.sessionStorage) === null || _window$sessionStorag2 === void 0 ? void 0 : _window$sessionStorag2.getItem(STORAGE_KEYS.epoch),
      trackerUuid: (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem(STORAGE_KEYS.trackerUuid)
    };
    return key.uuid && key.epoch && key.trackerUuid ? key : null;
  } catch (e) {
    return null;
  }
};

var MULTI_UUID_EVENTS = ['APP'];

var updateStoredEvents = function updateStoredEvents(eventType, uuid, event, parentUuid) {
  if (uuid) {
    try {
      var _window$localStorage2, _window$localStorage3;

      var data = (_window$localStorage2 = window.localStorage) === null || _window$localStorage2 === void 0 ? void 0 : _window$localStorage2.getItem(STORAGE_KEYS[APP_EVENT_KEYS[eventType]]);
      data = data ? JSON.parse(data) : {};

      if (MULTI_UUID_EVENTS.includes(eventType)) {
        if (!parentUuid) {
          (0, _utils.log)("updateStoredEvents ".concat(MULTI_UUID_EVENTS, " without parentUuid"), _utils.LEVELS.ERROR);
          return;
        }

        if (!data[parentUuid]) {
          data[parentUuid] = {};
        }

        if (!data[parentUuid][uuid]) data[parentUuid][uuid] = [];
        data[parentUuid][uuid] = [].concat((0, _toConsumableArray2["default"])(data[parentUuid][uuid]), [event]);
      } else {
        if (!data[uuid]) data[uuid] = [];
        data[uuid] = [].concat((0, _toConsumableArray2["default"])(data[uuid]), [event]);
      }

      (_window$localStorage3 = window.localStorage) === null || _window$localStorage3 === void 0 ? void 0 : _window$localStorage3.setItem(STORAGE_KEYS[APP_EVENT_KEYS[eventType]], JSON.stringify(data));
    } catch (e) {
      console.error(e);
    }
  } else {
    (0, _utils.log)("updateStoredEvents called without uuid", _utils.LEVELS.ERROR);
  }
};

var eventIsStored = function eventIsStored(event, eventType, uuid, parentUuid) {
  var eventsCache;

  try {
    var _window$localStorage4;

    eventsCache = (_window$localStorage4 = window.localStorage) === null || _window$localStorage4 === void 0 ? void 0 : _window$localStorage4.getItem(STORAGE_KEYS[APP_EVENT_KEYS[eventType]]);
  } catch (e) {
    return false;
  }

  if (eventsCache) {
    var events;
    eventsCache = JSON.parse(eventsCache);
    if (eventType === 'WEB') events = eventsCache['WEB'];else {
      if (MULTI_UUID_EVENTS.includes(eventType)) {
        var _eventsCache$parentUu;

        events = (_eventsCache$parentUu = eventsCache[parentUuid]) === null || _eventsCache$parentUu === void 0 ? void 0 : _eventsCache$parentUu[uuid];
      } else events = eventsCache[uuid];
    }
    return events && events.includes(event);
  }
};

var setGtmData = function setGtmData(event, profileUuid, appUuid, productType, profile, waitForGtmMs, org) {
  if (window.dataLayer) {
    (0, _utils.log)("Sending GTM event ".concat(event));
    var isFigure = org === _constants.ORGS.FIGURE;
    var isProvenance = org === _constants.ORGS.PROVENANCE;
    return new Promise(function (resolve) {
      var gtmData = {
        event: event
      };

      if (isFigure && profileUuid) {
        var _profile$name, _profile$name2, _profile$name3, _profile$name4;

        gtmData = _objectSpread(_objectSpread({}, gtmData), {}, {
          applicationId: appUuid || '',
          applicationType: productType,
          identityId: profileUuid,
          sha256Email: profile !== null && profile !== void 0 && profile.email ? (0, _jsSha.sha256)(profile === null || profile === void 0 ? void 0 : profile.email) : '',
          sha256FirstName: profile !== null && profile !== void 0 && (_profile$name = profile.name) !== null && _profile$name !== void 0 && _profile$name.firstName ? (0, _jsSha.sha256)(profile === null || profile === void 0 ? void 0 : (_profile$name2 = profile.name) === null || _profile$name2 === void 0 ? void 0 : _profile$name2.firstName) : '',
          sha256LastName: profile !== null && profile !== void 0 && (_profile$name3 = profile.name) !== null && _profile$name3 !== void 0 && _profile$name3.lastName ? (0, _jsSha.sha256)(profile === null || profile === void 0 ? void 0 : (_profile$name4 = profile.name) === null || _profile$name4 === void 0 ? void 0 : _profile$name4.lastName) : ''
        });

        if (profile !== null && profile !== void 0 && profile.addresses) {
          var homes = profile === null || profile === void 0 ? void 0 : profile.addresses.filter(function (address) {
            return address.type === 'HOME';
          });
          if (homes[0]) gtmData.sha256ZipCode = (0, _jsSha.sha256)(String(homes[0].zip));
        }
      }

      if (isProvenance && profileUuid) {
        gtmData = _objectSpread(_objectSpread({}, gtmData), {}, {
          applicationId: appUuid || '',
          applicationType: productType,
          identityId: profileUuid
        });
      }

      window.dataLayer.push(gtmData);
      setTimeout(function () {
        resolve();
      }, waitForGtmMs || 0);
    });
  }
};

var serviceIsDown = false;
var pendingSession = false;
var secureSessionEstablished = false;
var authenticationTimeout;
var secureSessionResolver;
var routeContext = _constants.CONTEXTS.EXTERNAL;
var AUTHENTICATION_DELAY_MS = 1000;
var UNKNOWN_PRODUCT_TYPE = 'UNKNOWN_PRODUCT_TYPE';
var RETRY_REASONS = {
  SESSION: 'SESSION',
  APP_UUID_INVALID: 'APP_UUID_INVALID',
  MISSING_UUID: 'MISSING_UUID'
};
var UUID_VALID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var params = (0, _utils.paramsToObj)((_window = window) === null || _window === void 0 ? void 0 : _window.document.location.search);

try {
  var _window2, _window2$sessionStora;

  if (params[_constants.DISABLE_EXPERIMENT]) (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$sessionStora = _window2.sessionStorage) === null || _window2$sessionStora === void 0 ? void 0 : _window2$sessionStora.setItem(_constants.DISABLE_EXPERIMENT, 'true');
} catch (e) {
  console.error(e);
}
/**
 * Wraps the application in a context that will store and handle telemetry session and data.
 * Loads and sends events {@link setGtmData} to GTM.
 * Caches utm params when user is switching organization domains {@link useStoredUtmParams}
 *
 * @param {string} gtmContainerId: GTM tag for this property
 * @param location - Pass in the dynamic location object
 * @param {string} location.pathname
 * @param {string} location.search
 * @param {string} appVersion - Version of the parent app, usually $npm_package_version
 * @param {string} [productType=UNKNOWN_PRODUCT_TYPE] {@link PRODUCTS}
 * @param {string} [org=FIGURE] {@link ORGS}
 * @param {string} defaultEventType - The event type APP | USER | WEB. Can be overwritten in the {@link telemetry} call.
 * @param {string} [applicationUuid] - Application uuid related to the event. Can be overwritten in the {@link telemetry} call.
 * @param [profile] - Pass in profile in authenticated Figure land
 * @param {string} [profile.uuid] - Required in figure land for secure context
 * @param [identity] - Pass in identity (Figure land) or identity.identity (Provenance land)
 * @param [identity.jwt] - Required in figure land for secure context
 * @param [identity.uuid] - Required in provenance land to identify user (In Figure land profile.uuid is used)
 * @param {boolean} [loadImpactRadius=false] - If using Impact Radius, set to true to load and initialize vendor scripts
 * @param {boolean} [delay] - If product type is {@link UNKNOWN_PRODUCT_TYPE} the context will not wait for authentication for {@link AUTHENTICATION_DELAY_MS} before firing initial events on the external context
 */


var TelemetryContextProvider = function TelemetryContextProvider(_ref) {
  var gtmContainerId = _ref.gtmContainerId,
      location = _ref.location,
      appVersion = _ref.appVersion,
      _ref$applicationUuid = _ref.applicationUuid,
      applicationUuid = _ref$applicationUuid === void 0 ? '' : _ref$applicationUuid,
      _ref$productType = _ref.productType,
      productType = _ref$productType === void 0 ? UNKNOWN_PRODUCT_TYPE : _ref$productType,
      _ref$org = _ref.org,
      org = _ref$org === void 0 ? _constants.ORGS.FIGURE : _ref$org,
      defaultEventType = _ref.defaultEventType,
      _ref$profile = _ref.profile,
      profile = _ref$profile === void 0 ? {} : _ref$profile,
      _ref$identity = _ref.identity,
      identity = _ref$identity === void 0 ? {} : _ref$identity,
      _ref$loadImpactRadius = _ref.loadImpactRadius,
      loadImpactRadius = _ref$loadImpactRadius === void 0 ? false : _ref$loadImpactRadius,
      delay = _ref.delay,
      children = _ref.children;
  if (!gtmContainerId) throw new Error('Telemetry loaded without GTM Container ID');
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _redux.bindActionCreators)(_actions.telemetryActions, dispatch);
  }, [dispatch]),
      session = _useMemo.session,
      triggerEvent = _useMemo.event;

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      userProperties = _useState2[0],
      setUserProperties = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isAuthenticated = _useState4[0],
      setIsAuthenticated = _useState4[1]; //if profile.uuid exists


  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      identityId = _useState6[0],
      setIdentityId = _useState6[1];

  var _useState7 = (0, _react.useState)(delay || productType !== UNKNOWN_PRODUCT_TYPE),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      waitForAuthentication = _useState8[0],
      setWaitForAuthentication = _useState8[1]; // wait for authentication if used in product


  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      retryCache = _useState10[0],
      setRetryCache = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      triggerRetry = _useState12[0],
      setTriggerRetry = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      badSessionEvents = _useState14[0],
      setBadSessionEvents = _useState14[1]; //after retrying a 404 event once it is sent here to prevent endless loop


  var pathnameRef = (0, _react.useRef)('');
  var waitForSecureSession = (0, _react.useCallback)(function (_ref2) {
    var timeoutMs = _ref2.timeoutMs;
    return new Promise(function (resolve) {
      if (secureSessionEstablished) {
        resolve();
      } else {
        secureSessionResolver = resolve;
        setTimeout(function () {
          if (secureSessionResolver) {
            secureSessionResolver();
            secureSessionResolver = null;
          }
        }, timeoutMs);
      }
    });
  }, []);

  var _useImpactRadius = (0, _useImpactRadius2["default"])(profile),
      impactRadiusTrack = _useImpactRadius.track;

  var storedUtmParams = (0, _useStoredUtmParams["default"])(location);
  (0, _react.useEffect)(function () {
    (0, _actions.setOrg)(org);
  }, [org]);
  (0, _react.useEffect)(function () {
    if (profile.uuid && identity.jwt) {
      if (routeContext !== _constants.CONTEXTS.SECURE) (0, _utils.log)("Context set: ".concat(_constants.CONTEXTS.SECURE));
      routeContext = _constants.CONTEXTS.SECURE;
      setIsAuthenticated(true);
    } else if (identity.uuid && org !== _constants.ORGS.FIGURE) {
      if (routeContext !== _constants.CONTEXTS.LOCAL) (0, _utils.log)("Context set: ".concat(_constants.CONTEXTS.LOCAL));
      routeContext = _constants.CONTEXTS.LOCAL;
      setIsAuthenticated(true);
    }

    if (identity.jwt) {
      (0, _actions.setAuthenticationHeaders)(identity.jwt);
    }
  }, [org, profile.uuid, identity.jwt, identity.uuid]);
  (0, _react.useEffect)(function () {
    setIdentityId((profile === null || profile === void 0 ? void 0 : profile.uuid) || (identity === null || identity === void 0 ? void 0 : identity.uuid));
  }, [profile, identity]);
  var telemetrySession = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var freshKey,
        key,
        resp,
        code,
        sessionKey,
        appEvents,
        userEvents,
        uuid,
        trackerUuid,
        epoch,
        _window$sessionStorag3,
        _window$sessionStorag4,
        _window$localStorage5,
        _window$localStorage6,
        _window$localStorage7,
        _args = arguments;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            freshKey = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            key = freshKey ? null : getSessionKey();
            pendingSession = true;
            _context.prev = 3;
            _context.next = 6;
            return session(key ? {
              sessionKey: key,
              appVersion: appVersion
            } : {
              appVersion: appVersion
            }, routeContext);

          case 6:
            resp = _context.sent;
            code = resp.code, sessionKey = resp.sessionKey, appEvents = resp.appEvents, userEvents = resp.userEvents;
            pendingSession = false;

            if (code && code === 200) {
              secureSessionEstablished = routeContext !== _constants.CONTEXTS.EXTERNAL;

              if (secureSessionEstablished) {
                (0, _utils.log)('Secure session established.');
              }

              uuid = sessionKey.uuid, trackerUuid = sessionKey.trackerUuid, epoch = sessionKey.epoch;

              try {
                (_window$sessionStorag3 = window.sessionStorage) === null || _window$sessionStorag3 === void 0 ? void 0 : _window$sessionStorag3.setItem(STORAGE_KEYS.uuid, uuid);
                (_window$sessionStorag4 = window.sessionStorage) === null || _window$sessionStorag4 === void 0 ? void 0 : _window$sessionStorag4.setItem(STORAGE_KEYS.epoch, epoch);
                (_window$localStorage5 = window.localStorage) === null || _window$localStorage5 === void 0 ? void 0 : _window$localStorage5.setItem(STORAGE_KEYS.trackerUuid, trackerUuid);
                if (appEvents) (_window$localStorage6 = window.localStorage) === null || _window$localStorage6 === void 0 ? void 0 : _window$localStorage6.setItem(STORAGE_KEYS.appEvents, JSON.stringify(appEvents));
                if (userEvents) (_window$localStorage7 = window.localStorage) === null || _window$localStorage7 === void 0 ? void 0 : _window$localStorage7.setItem(STORAGE_KEYS.userEvents, JSON.stringify(userEvents));
              } catch (e) {
                console.error(e);
              }

              setTimeout(function () {
                if (secureSessionEstablished && secureSessionResolver) {
                  secureSessionResolver();
                  secureSessionResolver = null;
                }
              }, 0);
              setTriggerRetry(true);
            }

            _context.next = 16;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
            serviceIsDown = true;
            (0, _utils.log)("Telemetry session server error ".concat(_context.t0), _utils.LEVELS.ERROR);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 12]]);
  })), [session, appVersion]);
  /**
   * Wrapper for {@link triggerEvent}
   * @param {string} event - The event name: helocStarted, helocOfferSelected, etc
   * @param [data]
   * @param {string} [data.applicationUuid] - Overwrites the context default applicationUuid
   * @param {string} [data.eventType] Overwrites the context default eventType APP | USER | WEB
   * @param {string} [data.profileUuid] - Overwrites the context default profileUuid
   *  The default is profile.uuid in Figure land and identity.uuid in Provenance land
   * @param {string} [data.email] - Overwrites the default user email
   *  The default is profile.email in Figure land
   * @param {boolean} [data.dontDedupe] - APP and USER events are deduped by default. Set this true to allow duplicate fires of the same event.
   * @param {boolean} [data.eventProperties] - {"eventPropertyKey1": "v1",} {"eventPropertyKey2":"v2"}, etc, all values must be strings
   * @param {string} [data.dedupeProperty] - Populate with the key of an event property to dedupe by its value like "eventPropertyKey1"
   * This overrides the default behavior of deduping APP events by appId and USER events by identity.
   * @param {string} [data.impactRadiusId] - Impact Radius Affiliate Tag ID. Make sure loadImpactRadius on {@link TelemetryContextProvider} was set to true for this to work.
   * @param {boolean} [data.waitForGtmMs] - Waits for specified ms before resolving. Use when the user is being redirected to another app and you want to wait for the GTM call to be sent.
    */

  var telemetryEvent = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
      var data,
          dataAppUuid,
          dataEventType,
          dataProfileUuid,
          dataEmail,
          waitForGtmMs,
          impactRadiusId,
          dataRest,
          sessionKey,
          eventType,
          appUuid,
          appUuidValidIfProvided,
          isDedupe,
          isProvenance,
          profileUuid,
          dedupe,
          _yield$Promise$all,
          _yield$Promise$all2,
          resp,
          code,
          _args2 = arguments;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              dataAppUuid = data.applicationUuid, dataEventType = data.eventType, dataProfileUuid = data.profileUuid, dataEmail = data.email, waitForGtmMs = data.waitForGtmMs, impactRadiusId = data.impactRadiusId, dataRest = (0, _objectWithoutProperties2["default"])(data, ["applicationUuid", "eventType", "profileUuid", "email", "waitForGtmMs", "impactRadiusId"]);
              sessionKey = getSessionKey();
              eventType = dataEventType || defaultEventType;
              appUuid = dataAppUuid || applicationUuid;
              appUuidValidIfProvided = !appUuid || appUuid && appUuid.match(UUID_VALID);
              isDedupe = !data.dontDedupe && _actions.telemetryActions.DEDUPE_EVENTS.includes(eventType) && !data.dedupeProperty;
              isProvenance = org === _constants.ORGS.PROVENANCE;
              profileUuid = dataProfileUuid || (isProvenance ? identity.uuid : profile === null || profile === void 0 ? void 0 : profile.uuid) || '';

              if (serviceIsDown) {
                setGtmData(event, profileUuid, appUuid, productType, profile, waitForGtmMs, org);
              }

              if (!(pendingSession || !sessionKey || _actions.telemetryActions.SECURE_EVENTS.includes(eventType) && !secureSessionEstablished)) {
                _context2.next = 14;
                break;
              }

              setRetryCache(function (retryCache) {
                return _objectSpread(_objectSpread({}, retryCache), {}, (0, _defineProperty2["default"])({}, event, {
                  type: RETRY_REASONS.SESSION,
                  data: data
                }));
              });
              (0, _utils.log)("Event ".concat(event, " sent to retry cache: ").concat(RETRY_REASONS.SESSION), _utils.LEVELS.ERROR);
              return _context2.abrupt("return");

            case 14:
              if (appUuidValidIfProvided) {
                _context2.next = 18;
                break;
              }

              setRetryCache(function (retryCache) {
                return _objectSpread(_objectSpread({}, retryCache), {}, (0, _defineProperty2["default"])({}, event, {
                  type: RETRY_REASONS.APP_UUID_INVALID,
                  data: data
                }));
              });
              (0, _utils.log)("Event ".concat(event, " sent to retry cache: ").concat(RETRY_REASONS.APP_UUID_INVALID), _utils.LEVELS.ERROR);
              return _context2.abrupt("return");

            case 18:
              if (!(_actions.telemetryActions.SECURE_EVENTS.includes(eventType) && (eventType === 'APP' && !appUuid || !profileUuid))) {
                _context2.next = 22;
                break;
              }

              setRetryCache(function (retryCache) {
                return _objectSpread(_objectSpread({}, retryCache), {}, (0, _defineProperty2["default"])({}, event, {
                  type: RETRY_REASONS.MISSING_UUID,
                  data: data
                }));
              });
              (0, _utils.log)("Event ".concat(event, " sent to retry cache: ").concat(RETRY_REASONS.MISSING_UUID), _utils.LEVELS.ERROR);
              return _context2.abrupt("return");

            case 22:
              if (!isDedupe) {
                _context2.next = 27;
                break;
              }

              if (eventType === 'APP') {
                dedupe = eventIsStored(event, eventType, appUuid, profileUuid);
              } else dedupe = eventIsStored(event, eventType, profileUuid);

              if (!dedupe) {
                _context2.next = 27;
                break;
              }

              (0, _utils.log)("Event ".concat(event, " rejected: Dedupe"));
              return _context2.abrupt("return");

            case 27:
              _context2.prev = 27;
              _context2.next = 30;
              return Promise.all([triggerEvent(_objectSpread({
                event: event,
                sessionKey: sessionKey,
                identityId: profileUuid,
                applicationUuid: appUuid,
                eventType: eventType,
                productType: productType,
                profile: profile
              }, dataRest), routeContext), function () {
                if (impactRadiusId) return impactRadiusTrack({
                  appUuid: appUuid,
                  identityUuid: profileUuid,
                  email: dataEmail || profile.email,
                  impactRadiusId: impactRadiusId,
                  event: event,
                  product: productType
                });
              }()]);

            case 30:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 1);
              resp = _yield$Promise$all2[0];
              code = resp.code;

              if (!(code === 404 && !badSessionEvents.includes(event))) {
                _context2.next = 42;
                break;
              }

              setBadSessionEvents([].concat((0, _toConsumableArray2["default"])(badSessionEvents), [event]));
              (0, _utils.log)("Telemetry event 404, initiating new session.");
              _context2.next = 39;
              return telemetrySession(true);

            case 39:
              setRetryCache(function (retryCache) {
                if (retryCache[event]) return retryCache;
                return _objectSpread(_objectSpread({}, retryCache), {}, (0, _defineProperty2["default"])({}, event, {
                  type: RETRY_REASONS.SESSION,
                  data: data
                }));
              });
              _context2.next = 45;
              break;

            case 42:
              if (!(code === 200)) {
                _context2.next = 45;
                break;
              }

              if (isDedupe) {
                if (eventType === 'APP') {
                  updateStoredEvents(eventType, appUuid, event, profileUuid);
                } else if (eventType === 'USER') {
                  updateStoredEvents(eventType, profileUuid, event);
                } else if (eventType === 'WEB') {
                  updateStoredEvents(eventType, 'WEB', event);
                }
              }

              return _context2.abrupt("return", setGtmData(event, profileUuid, appUuid, productType, profile, waitForGtmMs, org));

            case 45:
              _context2.next = 50;
              break;

            case 47:
              _context2.prev = 47;
              _context2.t0 = _context2["catch"](27);
              (0, _utils.log)("Telemetry event server error ".concat(_context2.t0), _utils.LEVELS.ERROR);

            case 50:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[27, 47]]);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [defaultEventType, applicationUuid, org, identity.uuid, profile, productType, triggerEvent, badSessionEvents, impactRadiusTrack, telemetrySession]);
  (0, _react.useEffect)(function () {
    if (!waitForAuthentication || isAuthenticated) {
      telemetrySession();
    } else {
      pendingSession = true;
      authenticationTimeout = setTimeout(function () {
        return setWaitForAuthentication(false);
      }, AUTHENTICATION_DELAY_MS);
    }

    if (isAuthenticated && authenticationTimeout) clearTimeout(authenticationTimeout); //eslint-disable-next-line
  }, [isAuthenticated, waitForAuthentication]);
  (0, _react.useEffect)(function () {
    var events = Object.keys(retryCache);

    if (events.length > 0) {
      setTriggerRetry(false);

      var go = /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  events.forEach(function (event) {
                    switch (retryCache[event].type) {
                      case RETRY_REASONS.SESSION:
                        if (!pendingSession) {
                          telemetryEvent(event, retryCache[event].data);
                          setRetryCache(function (retryCache) {
                            delete retryCache[event];
                            return retryCache;
                          });
                        }

                        break;

                      case RETRY_REASONS.APP_UUID_INVALID:
                        if (applicationUuid && applicationUuid.match(UUID_VALID)) {
                          telemetryEvent(event, retryCache[event].data);
                          setRetryCache(function (retryCache) {
                            delete retryCache[event];
                            return retryCache;
                          });
                        }

                        break;

                      case RETRY_REASONS.MISSING_UUID:
                        if (applicationUuid && profile.uuid) {
                          telemetryEvent(event, retryCache[event].data);
                          setRetryCache(function (retryCache) {
                            delete retryCache[event];
                            return retryCache;
                          });
                        }

                        break;

                      default:
                        break;
                    }
                  });

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function go() {
          return _ref5.apply(this, arguments);
        };
      }();

      go();
    }
  }, [retryCache, setRetryCache, telemetryEvent, triggerRetry, applicationUuid, profile.uuid]);
  (0, _react.useEffect)(function () {
    if (location !== null && location !== void 0 && location.pathname && location.pathname !== pathnameRef.current) {
      telemetryEvent('PAGEVIEW', {
        eventType: 'PAGEVIEW'
      });
      pathnameRef.current = location.pathname;
    }
  }, [location, applicationUuid, productType, telemetryEvent]);
  return /*#__PURE__*/_react["default"].createElement(TelemetryContext.Provider, {
    value: {
      /**
       * View docs {@link telemetryEvent}
       */
      telemetry: telemetryEvent,

      /**
       * Set {@link userProperties} consumed as attributes in {@link useOptimize}
       */
      setTelemetryUserProperties: setUserProperties,

      /**
       * Used internally {@link useOptimize}
       */
      isAuthenticated: isAuthenticated,

      /**
       * Used internally {@link useOptimize}
       */
      userProperties: userProperties,

      /**
       * Used internally {@link useOptimize}
       */
      waitForAuthentication: waitForAuthentication,

      /**
       * Async function that allows you to wait for a secure telemetry session to be established before contiuing.
       * @param {number} timeoutMs - Timeout required in case session service is down
       */
      waitForSecureSession: waitForSecureSession,

      /**
       * Used internally {@link useOptimize}
       */
      identityId: identityId,

      /**
       * Used internally {@link useOptimize}
       */
      globalRouteContext: routeContext,

      /**
       * Exposes stored Utm Params to use when redirecting user to external domain {@link useStoredUtmParams}
       */
      storedUtmParams: storedUtmParams
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("script", null, "window.dataLayer = window.dataLayer || [];\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                })(window,document,'script','dataLayer',\"".concat(gtmContainerId, "\");")), loadImpactRadius && /*#__PURE__*/_react["default"].createElement("script", null, "(function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://d.impactradius-event.com/A1289301-453d-4215-a460-4b9a21851dfd1.js','script','ire',document,window);")), children);
};

exports.TelemetryContextProvider = TelemetryContextProvider;
TelemetryContextProvider.propTypes = {
  gtmContainerId: _propTypes["default"].string.isRequired,
  location: _propTypes["default"].object.isRequired,
  appVersion: _propTypes["default"].string.isRequired,
  defaultEventType: _propTypes["default"].string.isRequired,
  applicationUuid: _propTypes["default"].string,
  productType: _propTypes["default"].string,
  profile: _propTypes["default"].object,
  identity: _propTypes["default"].object,
  children: _propTypes["default"].node.isRequired,
  loadImpactRadius: _propTypes["default"].bool,
  org: _propTypes["default"].string,
  delay: _propTypes["default"].bool
};
TelemetryContextProvider.defaultProps = {
  applicationUuid: '',
  productType: UNKNOWN_PRODUCT_TYPE,
  org: _constants.ORGS.FIGURE,
  profile: {},
  identity: {},
  loadImpactRadius: false,
  delay: false
};

var useTelemetry = function useTelemetry() {
  return (0, _react.useContext)(TelemetryContext);
};

exports.useTelemetry = useTelemetry;